import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuthStore } from 'stores/authStore'
import { useWebSocketContext } from 'context/WebSocketProvider'
import { useModal } from 'context/ModalContext'

import Notification from 'modules/Modals/Notification'

const Update = () => {
  const { t } = useTranslation()
  const { setAuth, auth, isAuth } = useAuthStore()
  const { lastMessage } = useWebSocketContext()
  const { openModal } = useModal()

  const updateBalance = (json) => {
    if (!isAuth()) return

    setAuth({
      ...auth,
      credits: json.credits,
    })
  }

  useEffect(() => {
    if (!lastMessage) return

    const { cmd, data, topic } = lastMessage

    if (cmd === 'update' && topic === 'credits') {
      updateBalance(data)
    }

    if (cmd === 'update' && topic === 'message') {
      openModal({
        title: data?.title || '',
        body: <Notification data={data} />
      })
    }
  }, [lastMessage])

  return null
}

export default Update
